export default "__VITE_ASSET__d047326b__"